import { captureUTMParams } from "./src/utils/utmParams";

// Save ad tracking params (cm_id + UTMs) before the first render.
// Double-slash URLs are collapsed earlier by an inline head script (gatsby-ssr.js).
export const onClientEntry = () => {
  captureUTMParams();
};

// Track chat state globally
let isChatOpen = false;

export const onRouteUpdate = () => {
  const buttons = document.querySelectorAll(".open-whatsapp-chat");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (
        window.leadConnector &&
        window.leadConnector.chatWidget &&
        typeof window.leadConnector.chatWidget.openWidget === "function" &&
        typeof window.leadConnector.chatWidget.closeWidget === "function"
      ) {
        const widget = window.leadConnector.chatWidget;

        // Toggle using local state
        if (isChatOpen) {
          widget.closeWidget();
          isChatOpen = false;
        } else {
          widget.openWidget();
          isChatOpen = true;
        }
      } else {
        console.warn("Chat widget is not ready yet");
      }
    });
  });
};
